import React from "react";

export const CardTask = ({ task, onClick, isActive }) => {


  console.log("isActive",isActive);
  
  // Define different color schemes for variety
  const getCardStyle = (title) => {
    const styles = {
      "Today's Tasks": {
        gradient: "from-blue-500 to-purple-600",
        bg: "bg-gradient-to-br from-blue-50 to-purple-50",
        accent: "text-blue-600"
      },
      "Weekly Tasks": {
        gradient: "from-emerald-500 to-teal-600",
        bg: "bg-gradient-to-br from-emerald-50 to-teal-50",
        accent: "text-emerald-600"
      },
      "Monthly Tasks": {
        gradient: "from-orange-500 to-red-600",
        bg: "bg-gradient-to-br from-orange-50 to-red-50",
        accent: "text-orange-600"
      },
      "One Time Tasks": {
        gradient: "from-violet-500 to-pink-600",
        bg: "bg-gradient-to-br from-violet-50 to-pink-50",
        accent: "text-violet-600"
      },
      "Missed Tasks": {
        gradient: "from-red-500 to-rose-600",
        bg: "bg-gradient-to-br from-red-50 to-rose-50",
        accent: "text-red-600"
      },
      "Completed Tasks": {
        gradient: "from-green-500 to-emerald-600",
        bg: "bg-gradient-to-br from-green-50 to-emerald-50",
        accent: "text-green-600"
      }
    };
        
    return styles[title] || styles["Today's Tasks"];
  };

  const cardStyle = getCardStyle(task.title);

  return (
    <div 
      className={`relative group ${isActive ? `bg-gradient-to-br ${cardStyle.gradient}` : cardStyle.bg} border ${isActive ? 'border-white/30' : 'border-white/20'} rounded-xl p-4 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer backdrop-blur-sm ${isActive ? 'scale-105 shadow-2xl' : ''}`} 
      onClick={onClick}
    >
      {/* Gradient overlay on hover */}
      <div className={`absolute inset-0 bg-gradient-to-br ${cardStyle.gradient} opacity-0 ${isActive ? 'opacity-0' : 'group-hover:opacity-5'} rounded-xl transition-opacity duration-300`}></div>
            
      {/* Decorative element */}
      <div className="relative flex justify-end mb-3">
        <div className="flex space-x-1">
          <div className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-white/80' : `bg-gradient-to-r ${cardStyle.gradient}`} ${isActive ? '' : 'opacity-60'}`}></div>
          <div className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-white/60' : `bg-gradient-to-r ${cardStyle.gradient}`} ${isActive ? '' : 'opacity-40'}`}></div>
          <div className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-white/40' : `bg-gradient-to-r ${cardStyle.gradient}`} ${isActive ? '' : 'opacity-20'}`}></div>
        </div>
      </div>

      {/* Content section */}
      <div className="relative">
        <h2 className={`text-sm font-semibold ${isActive ? 'text-white' : 'text-gray-800'} mb-2 leading-tight ${isActive ? 'text-white' : 'group-hover:text-gray-900'} transition-colors duration-300`}>
          {task.title}
        </h2>
                
        {/* Count with enhanced styling */}
        <div className="mb-3">
          <p className={`text-2xl font-bold ${isActive ? 'text-white' : cardStyle.accent} mb-1 group-hover:scale-105 transition-transform duration-300 inline-block`}>
            {task.count}
          </p>
          <div className={`h-0.5 w-8 ${isActive ? 'bg-white/50' : `bg-gradient-to-r ${cardStyle.gradient}`} rounded-full group-hover:w-10 transition-all duration-300`}></div>
        </div>
                
        <p className={`text-xs ${isActive ? 'text-white/80' : 'text-gray-600'} leading-relaxed ${isActive ? 'text-white/80' : 'group-hover:text-gray-700'} transition-colors duration-300`}>
          {task.description}
        </p>
      </div>

      {/* Bottom accent line */}
      <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${isActive ? 'bg-white/30' : `bg-gradient-to-r ${cardStyle.gradient}`} rounded-b-xl transform ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'} transition-transform duration-300 origin-left`}></div>
            
      {/* Subtle glow effect */}
      <div className={`absolute inset-0 rounded-xl bg-gradient-to-r ${cardStyle.gradient} opacity-0 ${isActive ? 'opacity-20' : 'group-hover:opacity-10'} blur-xl transition-opacity duration-300 -z-10`}></div>
    </div>
  );
};